import { render, staticRenderFns } from "./Meritfilter.vue?vue&type=template&id=00428b5e&"
import script from "./Meritfilter.vue?vue&type=script&lang=js&"
export * from "./Meritfilter.vue?vue&type=script&lang=js&"
import style0 from "./Meritfilter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports